import React from 'react';

const contactItems = [
    {
        id: 1,
        icon: (
            <>
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </>
        ),
        label: '总部地址',
        value: '江西省南昌市红谷滩区红谷中大道998号绿地中央广场A1#办公楼5206-2室',
        href: null,
    },
    {
        id: 2,
        icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
        ),
        label: '联系电话',
        value: '4001818105',
        href: 'tel:4001818105',
    },
    {
        id: 3,
        icon: (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        ),
        label: '电子邮箱',
        value: 'ryan@sayfamily.com',
        href: 'mailto:ryan@sayfamily.com',
    },
];

const ContactInfo = () => {
    return (
        <div id="contact" className="bg-gradient-to-br from-gray-50 to-blue-50 py-14 md:py-16">
            <section>
                <div className="container mx-auto px-4 md:px-8">
                    {/* 标题 */}
                    <div className="text-center mb-10">
                        <h2 className="text-3xl md:text-4xl font-bold text-gray-800">联系我们</h2>
                    </div>

                    {/* 信息卡片 */}
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
                        {contactItems.map((item) => {
                            const inner = (
                                <>
                                    <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center shadow-md mb-4">
                                        <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            {item.icon}
                                        </svg>
                                    </div>
                                    <p className="text-sm text-gray-400 mb-1">{item.label}</p>
                                    <p className="text-gray-800 font-medium leading-relaxed break-words">{item.value}</p>
                                </>
                            );

                            return item.href ? (
                                <a
                                    key={item.id}
                                    href={item.href}
                                    className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow duration-300 border border-gray-100"
                                >
                                    {inner}
                                </a>
                            ) : (
                                <div
                                    key={item.id}
                                    className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow duration-300 border border-gray-100"
                                >
                                    {inner}
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default ContactInfo;
